import React, { useEffect, useRef, useState } from "react";
import AmendmentPdfViewerModal, { amendmentPdfEndpoint } from "./AmendmentPdfViewer";
import SourceEvidenceLink, { amendmentEvidence } from "./SourceEvidenceLink";

/** 세번/연번만 서버에 보내며, 파일 버전과 물리 쪽수는 검증한 서버 응답을 사용한다. */
export default function AmendmentOriginalButton({ amendment, hsk, label = "변경고시 원문" }) {
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const request = useRef(null);
  const trigger = useRef(null);
  const seqNo = amendment?.seq ?? amendment?.seq_no ?? amendment?.seqNo;
  const evidenceHsk = amendment?.integrity_status === "matched" && amendment?.hs_after ? amendment.hs_after : hsk;
  const endpoint = amendmentPdfEndpoint({ hsk: evidenceHsk, seqNo });
  useEffect(() => {
    setDocument(null); setLoading(false); setError(false);
    return () => request.current?.abort();
  }, [endpoint]);
  const official = amendmentEvidence({ sourceLandingUrl: amendment?.source_url }).landing;
  async function open(event) {
    event.stopPropagation();
    request.current?.abort();
    const controller = new AbortController();
    request.current = controller;
    setLoading(true); setError(false);
    try {
      const response = await fetch(endpoint.replace("/pdf?", "/document-info?"), { signal: controller.signal });
      if (!response.ok) throw new Error("PDF unavailable");
      const data = await response.json();
      if (!/^[A-Fa-f0-9]{64}$/.test(data.sha256)
          || data.url !== `${endpoint}&document=true&sha256=${data.sha256}`
          || !Number.isInteger(data.startPage) || !Number.isInteger(data.endPage)
          || !Number.isInteger(data.pageCount) || data.startPage < 1
          || data.endPage < data.startPage || data.endPage > data.pageCount) throw new Error("invalid PDF metadata");
      if (!controller.signal.aborted) setDocument(data);
    } catch (failure) {
      if (!controller.signal.aborted) setError(true);
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }
  if (!endpoint) return <SourceEvidenceLink compact {...official} label={label} />;
  return <>
    <button ref={trigger} type="button" onClick={open} disabled={loading}
      style={{ padding: "3px 8px", border: "1px solid var(--audit-border, #cbd5e1)", borderRadius: 5,
        background: "var(--audit-bg, #fff)", color: "var(--audit-accent, #2563eb)", font: "inherit", fontSize: 12, cursor: "pointer" }}>
      {loading ? "공식 PDF 확인 중…" : label}
    </button>
    {error && <span role="alert" style={{ fontSize: 12 }}> 원본 PDF를 불러오지 못했습니다. 다시 시도하거나 <SourceEvidenceLink compact {...official} label="국가법령정보센터에서 보기" /></span>}
    {document && <AmendmentPdfViewerModal hsk={evidenceHsk} item={{ seqNo, title: amendment?.title,
      gosiNo: amendment?.gosi_no, sourceLandingUrl: amendment?.source_url, document }}
      onClose={() => { setDocument(null); trigger.current?.focus(); }} />}
  </>;
}
